import React from 'react';
import PropTypes from 'prop-types';
import { withStyles } from '@material-ui/core/styles';
import { Divider, Grid, Typography, Modal } from '@material-ui/core';
import {Card, CardContent, CardActions, CardHeader } from '@material-ui/core';
import Info from '../Info';
import SubscriptionStatus from '../subscriptions/SubscriptionStatus';
import { FormattedMessage } from 'react-intl';
import DenyInvitationButton from './DenyInvitationButton';
import AcceptInvitationButton from './AcceptInvitationButton';

/**
 * Invitation card, displayed in a product panel when a user is invited to use someone
 * else's subscription
 */

const styles = theme => ({
  card: {
    margin: 'auto',
    width: '60%',
  },
  acceptInvitationWarning: {
    fontWeight:700,
    display:'block',
    marginBottom: 16
  },
  acceptInvitation: {
    display:'block'
  }
})

const InvitationModal = ({ invitation, handleAccept, handleDeny, classes }) => (
  <Modal open style={{display:'flex'}}>
    <Card className={classes.card}>
      <CardHeader
        title={
          <span>
            <Typography variant="caption">
              <FormattedMessage id='invitation.label' />
            </Typography>
            <Typography variant="subtitle1">
              {invitation.licence.plan.name}
            </Typography>
          </span>
        }
      />
      <Divider />
      <CardContent>
        <Info>
          <FormattedMessage id='invitation.subscription.info' />
        </Info>
      </CardContent>
      <Divider />
      <CardContent>
        <Grid container spacing={24} alignItems="center">
          <Grid item sm={4} xs={12}>
            <SubscriptionStatus subscription={invitation.licence} />
          </Grid>
          <Grid item sm xs={12}>
            <Typography variant="caption">
              <FormattedMessage id='subscription.owner.label' />
            </Typography>
            <Typography component="p">{invitation.licence.owner.email}</Typography>
          </Grid>
        </Grid>
      </CardContent>
      <Divider />
      <CardActions>
        <AcceptInvitationButton 
          invitation={invitation}
          handleAccept={handleAccept}
        />
        <DenyInvitationButton
          invitation={invitation}
          handleDeny={handleDeny}
        />
      </CardActions>
    </Card>
  </Modal>
)

InvitationModal.propTypes = {
  invitation: PropTypes.object.isRequired,
  handleAccept: PropTypes.func.isRequired,
  handleDeny: PropTypes.func.isRequired,
  classes: PropTypes.object.isRequired
}

export default withStyles(styles)(InvitationModal);


// WEBPACK FOOTER //
// ./src/components/invitations/InvitationModal.js